import { render } from "./ExtinguisherRegister.vue?vue&type=template&id=45780c78&scoped=true&ts=true"
import script from "./ExtinguisherRegister.vue?vue&type=script&lang=ts"
export * from "./ExtinguisherRegister.vue?vue&type=script&lang=ts"

import "./ExtinguisherRegister.vue?vue&type=style&index=0&id=45780c78&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45780c78"]])

export default __exports__